import {
  MeetingManager,
  MeetingProvider,
  UserActivityProvider,
} from 'amazon-chime-sdk-component-library-react'
import { ConsoleLogger, LogLevel } from 'amazon-chime-sdk-js'
import { ChimeMeeting } from './ChimeMeeting'

const chimeMeetingManager = new MeetingManager(
  new ConsoleLogger('ChimeSDK', LogLevel.WARN),
)

export const ChimeCabinLivestream = ({
  credentials,
  vehicleId,
  onConnectionLost,
  onConnected,
}: {
  credentials: string
  vehicleId: string
  onConnectionLost: () => void
  onConnected?: () => void
}) => {
  return (
    <UserActivityProvider>
      <MeetingProvider meetingManager={chimeMeetingManager}>
        <ChimeMeeting
          credentials={credentials}
          vehicleId={vehicleId}
          onConnectionLost={onConnectionLost}
          onConnected={onConnected}
        />
      </MeetingProvider>
    </UserActivityProvider>
  )
}
